import { PlusIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';

interface AddRebateButtonProps {
  variant?: 'button' | 'iconButton';
}

const AddRebateButton: React.FC<AddRebateButtonProps> = ({
  variant = 'button',
}) => {
  const { currentOption } = useAppointmentProposalOptions();
  const isReadOnly = currentOption?.isReadOnly || false;

  if (variant === 'iconButton') {
    return (
      <IconButton
        component={Link}
        to={'query-modifiers'}
        color="gold"
        size="small"
        disabled={isReadOnly}
      >
        <PlusIcon />
      </IconButton>
    );
  }

  return (
    <Button
      component={Link}
      to={'query-modifiers'}
      color="softGold"
      endIcon={<PlusIcon />}
      disabled={isReadOnly}
    >
      Add more
    </Button>
  );
};

export default AddRebateButton;
